import React from 'react';

import { Divider } from 'ui-components/components/divider';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { DetailField } from '../../../components/detail-field/detail-field';
import { messages } from '../../messages';
import styles from './transfer-details.styles.module.less';

type TransferDetailsProps = {
  originWarehouseName: string;
  destinationWarehouseName: string;
};

export const TransferDetails = ({ originWarehouseName, destinationWarehouseName }: TransferDetailsProps) => {
  return (
    <div className={styles.container}>
      <Text className={styles['section-title']} textType={TextType.H4} value={messages.transferDetails} />
      <FlexRow className={styles['details-grid']}>
        <DetailField className={styles['details-column']} label={messages.originWarehouse} value={originWarehouseName} />
        <DetailField className={styles['details-column']} label={messages.destinationWarehouse} value={destinationWarehouseName} />
      </FlexRow>
      <Divider className={styles.divider} orientation='horizontal' />
    </div>
  );
};
